import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=2ca720b0&scoped=true&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=2ca720b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca720b0",
  null
  
)

export default component.exports